import {gql} from 'graphql-request'
import {MEDIA_FRAGMENT} from './fragments'

export const brandsQuery = gql`
    ${MEDIA_FRAGMENT}
    query Brands($locale: String!) {
        brandCollection(limit: 200, locale: $locale, order: [name_ASC]) {
            items {
                name
                headline
                code: uniqueName
                logo {
                    ...MediaFragment
                }
                bannerImage {
                    ...MediaFragment
                }
                availability
                categoryCollection(limit: 15) {
                    items {
                        name
                        slug
                    }
                }
                placeOfOrigin
                description
                plpUrl
            }
        }
    }
`
